import { combineReducers } from 'redux'
import {tabMode , expandMode , setTitle , setSocket} from './reducers'

export default combineReducers({
    tabMode,
    expandMode,
    setTitle,
    setSocket
})
